import * as React from 'react';

const ColorBox = ({ name, color, className }) => (
  <div className={`d-flex justify-content-between p-8 ${className}`}>
    <span>{name}</span>
    <span>{color}</span>
  </div>
);

const ColorPalette = () => {
  return (
    <div className='row'>
      <div className='col-3'>
        <ColorBox name='Dark' color='#0C0C0B' className='bg-dark text-white' />
        <ColorBox name='Danger' color='#A41C00' className='bg-danger text-white' />
        <ColorBox name='Primary' color='#FF411A' className='bg-primary text-white' />
        <ColorBox name='Orange Light' color='#FEF0EE' className='bg-orange-light' />
        <ColorBox name='White' color='#FFFFFF' className='bg-white' />
      </div>
      <div className='col-3'>
        <ColorBox name='Gray' color='#D8D8D8' className='bg-gray' />
        <ColorBox name='Gray Light' color='#F8F8F8' className='bg-gray-light' />
      </div>
    </div>
  );
};

export default ColorPalette;
